import React from "react";

export default function SingleHealthStatus({ title, items }) {
  return (
    <div className="healthStatusBlock">
      <div className="healthStatus">
        <div className="healthStatusTitle">{title}</div>
        {/* <button className="healthStatusEdit">Edit</button> */}
      </div>

       <div className="healthStatusBadgeGroup">
       <div className="healthStatusBadge">{items}</div>
      </div>

      {/* <div className="healthStatusBadgeGroup">
        {items?.map((item, idx) => (
          <div className="healthStatusBadge">{item}</div>
        ))}
      </div> */}
    </div>
  );
}
